// Hook: Angel One authentication management
import { useState, useCallback } from 'react';
import { useTrading } from '../context/TradingContext';

export function useAngelOneAuth() {
  const { login, logout, connectionStatus, connectionError, profile, clientcode } = useTrading();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = useCallback(async (clientcode, password, totp) => {
    setLoading(true);
    setError(null);
    try {
      const result = await login({ clientcode, password, totp });
      if (!result.success) {
        setError(result.message);
      }
      return result;
    } catch (err) {
      const msg = err.message || 'Connection failed';
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  }, [login]);

  const handleLogout = useCallback(async () => {
    setLoading(true);
    try {
      await logout();
    } finally {
      setLoading(false);
      setError(null);
    }
  }, [logout]);

  return {
    login: handleLogin,
    logout: handleLogout,
    loading,
    error: error || connectionError,
    isConnected: connectionStatus === 'connected',
    isConnecting: connectionStatus === 'connecting',
    connectionStatus,
    profile,
    clientcode,
  };
}
